import React from "react";
import "./SelectedExcursion.css";
import UsersList from "./UsersList";
import SamplesList from "./SamplesList";

function SelectedExcursion({ excursion }) {
    return (
        <div className="Selected_excursion">
            <div className="Selected_excursion_header">
                <h2>{excursion.name}</h2>
                <p>{excursion.created_at}</p>
                {excursion.finished_at && <p>{excursion.finished_at}</p>}
            </div>
            <div className="Selected_excursion_content">
                <div className="Selected_excursion_users_list">
                    <UsersList id={excursion.id} />
                </div>
                <div className="Selected_excursion_samples_list">
                    <SamplesList id={excursion.id} />
                </div>
            </div>
        </div>
    );
}

export default SelectedExcursion;
